"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexFlightAirlines = [
    { code: "A3", name: "Aegean Airlines" },
    { code: "AC", name: "Air Canada" },
    { code: "UX", name: "Air Europa" },
    { code: "AF", name: "Air France" },
    { code: "AA", name: "American Airlines" },
    { code: "OS", name: "Austrian Airlines" },
    { code: "BA", name: "British Airways" },
    { code: "SN", name: "Brussels Airlines" },
    { code: "CX", name: "Cathay Pacific" },
    { code: "DE", name: "Condor" },
    { code: "DL", name: "Delta Airlines" },
    { code: "U2", name: "Easyjet" },
    { code: "EK", name: "Emirates" },
    { code: "EY", name: "Etihad Airways" },
    { code: "EW", name: "Eurowings" },
    { code: "4Y", name: "Eurowings Discover" },
    { code: "AY", name: "Finnar" },
    { code: "IB", name: "Iberia" },
    { code: "AZ", name: "ITA Airways" },
    { code: "KL", name: "KLM" },
    { code: "LH", name: "Lufthansa" },
    { code: "LG", name: "Luxair" },
    { code: "QR", name: "Qatar Airways" },
    { code: "FR", name: "Ryanair" },
    { code: "SK", name: "Scandinavian Airlines" },
    { code: "SQ", name: "Singapore Airlines" },
    { code: "XQ", name: "Sunexpress" },
    { code: "LX", name: "Swiss" },
    { code: "TP", name: "TAP Portugal" },
    { code: "TG", name: "Thai Airways International" },
    { code: "X3", name: "TUIfly" },
    { code: "TK", name: "Turkish Airlines" },
    { code: "UA", name: "United Airlines" },
    { code: "VY", name: "Vueling" },
].sort(function (a, b) { return a.name.localeCompare(b.name, 'de'); });
exports.maxSelectableAirlinesCount = 3;
exports.default = {
    flexFlightAirlines: exports.flexFlightAirlines,
    maxSelectableAirlinesCount: exports.maxSelectableAirlinesCount,
};
//# sourceMappingURL=master_data.js.map